import { Controller, useFormContext } from 'react-hook-form';
import { Form } from 'rsuite';
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import NepaliDatePicker, { NepaliDate } from '@zener/nepali-datepicker-react';
import React from 'react';


interface Props {
    name: string;
    label?: string;
    maxDate?: NepaliDate;
    dateFormat?: string;
    language?: 'en' | 'np';
    defaultDate?: string;
    className?: string;
    placeholder?: string;
}

const NepaliDatePickerInput = ({
    name,
    label,
    maxDate,
    language = 'en',
    className,
    placeholder = 'Select Date',
}: Props) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();


    return (
        <Form>
            <Form.Group controlId={name}
                className={`space-y-2 ${className || ''}`}
            // className="nepali-datepicker-style nepali-datepicker-dob mb-0"
            >
                {label && <Form.ControlLabel>{label}</Form.ControlLabel>}

                <Controller
                    name={name}
                    control={control}
                    render={({ field }) => {
                        return <Form.Control
                            name={field.name}
                            accepter={NepaliDatePicker}
                            className="rs-input rs-input-lg"
                            lang={language}
                            max={maxDate}
                            placeholder={placeholder}
                            value={field.value || null}
                            showclear={false}
                            onChange={(e) => {
                                const formattedDate = e?.format('YYYY-MM-DD');
                                field.onChange(formattedDate)
                            }}
                        />
                    }}
                />

                <Form.ErrorMessage show={!!errors[name]} placement="bottomStart">
                    {String(errors[name]?.message) || 'यो फिल्ड अनिवार्य छ'}
                </Form.ErrorMessage>
            </Form.Group>
        </Form>
    );
};

export default NepaliDatePickerInput;
